import type { ImgHTMLAttributes } from 'react'

import { useGeoserverImageUrl } from 'common/geoserver'

type GeoserverImageProps = ImgHTMLAttributes<HTMLImageElement>

/**
 * <img> for a URL that may point at GeoServer, which needs an Authorization
 * header a plain src cannot send. Other URLs (data URIs, static assets) render
 * as-is. Renders nothing until a GeoServer image has loaded.
 */
const GeoserverImage = ({ src, alt, ...props }: GeoserverImageProps) => {
  const resolvedSrc = useGeoserverImageUrl(src)
  return resolvedSrc ? <img src={resolvedSrc} alt={alt} {...props} /> : null
}

export default GeoserverImage
